<template lang="pug">
.form
  .form__block(v-show="!sendForm")
    h3(v-html="formTitle")

    .form__fields
      label.input-text
        input.input-text__input(
          type="text"
          v-model="fieldName"
          :placeholder="formFieldNamePlaceholder"
        )

      label.input-text
        input.input-text__input(
          type="text"
          v-model="fieldNameLong"
          :placeholder="formFieldNameLongPlaceholder"
        )

      label.input-text
        input.input-text__input(
          type="email"
          v-model="fieldEmail"
          :placeholder="formFieldEmailPlaceholder"
        )

      label.input-text
        input.input-text__input(
          type="tel"
          v-model="fieldPhone"
          :placeholder="formFieldPhonePlaceholder"
          v-maska="['+7 (###) ##-##-##', '+7 (###) ###-##-##']"
        )

    .form__comment
      label.input-textarea
        span.input-textarea__title(v-html="formFieldCommentTitle")

        textarea.input-textarea__input(
          v-model="fieldComment"
          :placeholder="formFieldCommentPlaceholder"
        )

    .form__text.form__text-mobile(v-html="formConsentText")

    .form__button
      .button.button-green(
        :class="{'button-disable': v$.$invalid}"
        @click="getSend()"
      )
        .button__text(v-html="formButtonName")

    .form__text.form__text-desk(v-html="formConsentText")

  .form__block(v-show="sendForm")
    h3(v-html="formSuccessTitle" )
    p(v-html="formSuccessText")

</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import { mapActions } from 'vuex'
export default {
  name: 'AppForm',

  setup () {
    return { v$: useVuelidate() }
  },

  props: [
    "formSettingTitle",
    "formSettingSubject",

    "formTitle",
    "formButtonName",

    "formFieldName",
    "formFieldNamePlaceholder",
    "formFieldNameLong",
    "formFieldNameLongPlaceholder",
    "formFieldEmail",
    "formFieldEmailPlaceholder",
    "formFieldPhone",
    "formFieldPhonePlaceholder",
    "formFieldComment",
    "formFieldCommentTitle",
    "formFieldCommentPlaceholder",
    "formFieldPage",

    "formSuccessTitle",
    "formSuccessText",

    "formConsentText",

    "formPageId",
    "formPagePagetitle",
  ],

  data () {
    return {
      fieldName: '',
      fieldNameLong: '',
      fieldEmail: '',
      fieldPhone: '',
      fieldComment: '',
      files: '',
      sendForm: false
    }
  },

  methods: {
    ...mapActions([
      'Send'
    ]),

    getSend () {
      if (!this.v$.$invalid) {
        this.sendForm = !this.sendForm

        this.Send({
          setting: {
            title: this.formSettingTitle,
            subject: this.formSettingSubject
          },

          fields: [
            {
              title: this.formFieldName,
              value: this.fieldName
            },
            {
              title: this.formFieldNameLong,
              value: this.fieldNameLong
            },
            {
              title: this.formFieldEmail,
              value: this.fieldEmail
            },
            {
              title: this.formFieldPhone,
              value: this.fieldPhone
            },
            {
              title: this.formFieldComment,
              value: this.fieldComment
            },
            {
              title: this.formFieldPage,
              value: this.formPagePagetitle + ' (' + this.formPageId + ')'
            },
          ],
          files: this.files
        })

        this.fieldName = this.fieldNameLong = this.fieldEmail = this.fieldPhone = this.fieldComment = ''

        setTimeout(() => {
          this.sendForm = !this.sendForm
        }, 3500)
      }
    }
  },

  validations () {
    return {
      fieldPhone: {
        required,
        minLength: minLength(18),
        maxLength: maxLength(18)
      }
    }
  }
}
</script>
